import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
const ClientFooter = () => {
  return (
    <footer className="bg-dark text-white text-center p-3">
      <Container>
        <p>
          &copy; {new Date().getFullYear()} Texas School of Mental Health. All Rights Reserved.
        </p>
        <div className="mt-2">
          <Link to="/privacy-policy" className="text-white me-3">Privacy Policy</Link>&nbsp;&nbsp;&nbsp;&nbsp;
          <Link to="/TermsOfUse" className="text-white me-3">Terms of Use</Link>&nbsp;&nbsp;&nbsp;&nbsp;
          <Link to="/AboutUs" className="text-white me-3">About Us</Link>&nbsp;&nbsp;&nbsp;&nbsp;
          <Link to="/ContactUs" className="text-white">Contact Us</Link>&nbsp;&nbsp;&nbsp;
          <Link to="/Support" className="text-white me-3">Support</Link>&nbsp;&nbsp;&nbsp;&nbsp;
          <Link to="/Documentation" className="text-white me-3">Documentation</Link>&nbsp;&nbsp;&nbsp;&nbsp;
          <Link to="/Install" className="text-white">Install</Link>&nbsp;&nbsp;&nbsp;
        </div>
      </Container>
    </footer>
  );
};

export default ClientFooter;
